// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.

import { BaseAnthropic } from '../client';

export abstract class APIResource {
  protected _client: BaseAnthropic;

  constructor(client: BaseAnthropic) {
    this._client = client;
  }
}
